import QuestionType, { HiddenFieldType } from './questionType';
import {
  initialEmailFieldValues,
  initialHiddenFieldValues,
  initialNameFieldValues,
  initialOptionsFieldValues,
  initialPhoneFieldValues,
  initialTextFieldValues,
  initialNumberFieldValues,
  initialLengthFieldValues,
  initialWeightFieldValues,
  initialDateFieldValues,
} from './validation';

const InitialQuestions = {
  [QuestionType.TEXT]: { ...initialTextFieldValues },
  [QuestionType.NUMBER]: { ...initialNumberFieldValues },
  [QuestionType.EMAIL]: { ...initialEmailFieldValues },
  [QuestionType.NAME]: { ...initialNameFieldValues },
  [QuestionType.OPTIONS]: { ...initialOptionsFieldValues },
  [QuestionType.PHONE]: { ...initialPhoneFieldValues },
  [QuestionType.LENGTH]: { ...initialLengthFieldValues },
  [QuestionType.WEIGHT]: { ...initialWeightFieldValues },
  [QuestionType.DATE]: { ...initialDateFieldValues },
  [HiddenFieldType.TEXT]: { ...initialHiddenFieldValues },
};

export default InitialQuestions;
